import React, { useState, useEffect } from 'react';

const ZERO_GUID = '00000000-0000-0000-0000-000000000000';

function SettingsScreen() {
  const [interval, setInterval] = useState(10);
  const [isIntervalValid, setIsIntervalValid] = useState(true);
  const [numLeagues, setNumLeagues] = useState(2);
  const [tournamentOwner, setTournamentOwner] = useState('');
  const [isTournamentOwnerValid, setIsTournamentOwnerValid] = useState(true);

  useEffect(() => {
    const storedInterval = localStorage.getItem('leagueSwitchInterval');
    if (storedInterval) {
      setInterval(parseInt(storedInterval, 10));
    }
    const storedNumLeagues = localStorage.getItem('numLeaguesToShow');
    if (storedNumLeagues) {
      setNumLeagues(parseInt(storedNumLeagues, 10));
    }
    let storedTournamentOwner = localStorage.getItem('tournamentOwner');
    if (!storedTournamentOwner) {
      storedTournamentOwner = ZERO_GUID;
    }
    setTournamentOwner(storedTournamentOwner);
  }, []);

  const handleIntervalChange = (e) => {
    const newInterval = e.target.value;
    setInterval(newInterval);
    const newIntervalInt = parseInt(newInterval, 10);
    if (!isNaN(newIntervalInt) && newIntervalInt >= 1) {
      setIsIntervalValid(true);
      localStorage.setItem('leagueSwitchInterval', newIntervalInt);
    } else {
      setIsIntervalValid(false);
    }
  };

  const handleNumLeaguesChange = (e) => {
    const newNumLeagues = parseInt(e.target.value, 10);
    setNumLeagues(newNumLeagues);
    localStorage.setItem('numLeaguesToShow', newNumLeagues);
  };

  const handleTournamentOwnerChange = (e) => {
    const newTournamentOwner = e.target.value;
    setTournamentOwner(newTournamentOwner);
    // Basic GUID check
    const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    if (guidRegex.test(newTournamentOwner)) {
      setIsTournamentOwnerValid(true);
      localStorage.setItem('tournamentOwner', newTournamentOwner);
    } else {
      setIsTournamentOwnerValid(false);
    }
  };

  const handleGenerateOwner = () => {
    const newTournamentOwner = crypto.randomUUID();
    setTournamentOwner(newTournamentOwner);
    localStorage.setItem('tournamentOwner', newTournamentOwner);
  };

  return (
    <div className="card">
      <div className="card-header">
        <h2>Settings</h2>
      </div>

      <div className="form-group" style={{ maxWidth: '400px', marginBottom: '2rem' }}>
        <label htmlFor="interval-input">Live Page Switch Interval (seconds)</label>
        <input
          id="interval-input"
          type="number"
          value={interval}
          onChange={handleIntervalChange}
          min="1"
        />
        {!isIntervalValid && <span style={{ color: 'var(--danger-color)', fontSize: '0.875rem' }}>Please enter a valid number (1 or greater)</span>}
        <p style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', margin: '0.5rem 0 0 0' }}>
          Set how long each league is displayed on the Live page before switching to the next one.
        </p>
      </div>

      <div className="form-group" style={{ maxWidth: '400px', marginBottom: '2rem' }}>
        <label htmlFor="num-leagues-select">Number of Leagues on Live Page</label>
        <div className="select-container">
          <select
            id="num-leagues-select"
            value={numLeagues}
            onChange={handleNumLeaguesChange}
          >
            <option value="1">1 (shown with results)</option>
            <option value="2">2 (shown with results)</option>
            <option value="4">4 (without results)</option>
          </select>
        </div>
        <p style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', margin: '0.5rem 0 0 0' }}>
          Choose how many leagues to display simultaneously on the Live page.
        </p>
      </div>

      <div className="form-group" style={{ maxWidth: '590px' }}>
        <label htmlFor="tournament-owner-input">Tournament Owner ID</label>
        <div className="settings-button-group">
          <input
            id="tournament-owner-input"
            type="text"
            value={tournamentOwner}
            onChange={handleTournamentOwnerChange}
            style={{ flex: 1 }}
          />
          <div className="settings-buttons">
            {tournamentOwner === ZERO_GUID && (
              <button onClick={handleGenerateOwner}>
                Generate New
              </button>
            )}
            <button
              onClick={() => navigator.clipboard.writeText(tournamentOwner)}
              disabled={!tournamentOwner}
            >
              Copy
            </button>
          </div>
        </div>
        {!isTournamentOwnerValid && <span style={{ color: 'var(--danger-color)', fontSize: '0.875rem' }}>Please enter a valid GUID</span>}
        <p style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', margin: '0.5rem 0 0 0' }}>
          Unique identifier for this tournament. Share this ID to allow others to view and edit your tournament.
        </p>
      </div>
    </div>
  );
}

export default SettingsScreen;
